<template>
	<div v-if="loadingHtmlContent" class="d-flex align-center justify-space-between" style="gap: 6px;">
		<div>
			<p class="font-weight-bold mb-0 caption">Cargando Contenido del Documento</p>
			<p class="mb-0" style="font-size: 10px;line-height: 10px;">El contenido de este documento es de mayor tamaño, tomará unos segundos más de lo normal.</p>
		</div>
		<v-progress-circular
			indeterminate
			color="#524D4D"
			width="1"
			size="16"
		></v-progress-circular>
	</div>
	<div class="d-flex flex-1 flex-column flex-grow-1" style="width: 100%;" v-else>
		<!-- <p class="mb-0 font-weight-bold caption grey--text">Plantillas</p> -->
		<div v-if="createNewTemplate" class="d-flex align-center" style="gap: 6px;">
			<v-text-field
				v-model="newTemplateName"
				label="Nombre plantilla"
				placeholder="Nombre plantilla"
				outlined
				required
				dense
				hide-details
				maxlength="255"
				:color="color"
				:style="textFieldStyle"
				class="custom-height-search custom-height-calendar custom-dynamic-color"
			/>
			<div class="d-flex align-center" style="gap: 6px;">
				<v-btn
					icon
					x-small
					:color="color"
					@click="createNewTemplate = false"
				>
					<v-icon>mdi-close</v-icon>
				</v-btn>
				<v-btn
					icon
					x-small
					:color="color"
					@click="saveItemContentAsTemplate"
				>
					<v-icon>mdi-check</v-icon>
				</v-btn>
			</div>
		</div>
		<div class="d-flex align-center flex-grow-1" style="gap: 6px;width: 100%;" v-else>
			<v-menu
				ref="menu"
				v-model="menuTemplates"
				transition="scale-transition"
				offset-y
				left
				nudge-top="-10"
				eager
				max-width="400"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						depressed
						:color="color"
						outlined
						small
						class="d-flex flex-1"
						:dark="!loadingCompanyTemplates && !disabled"
						:disabled="loadingCompanyTemplates || disabled"
						v-bind="attrs"
						v-on="on"
					>
						<div class="d-flex align-center justify-space-between py-1 w-100" v-if="loadingCompanyTemplates">
							<p class="mb-0 caption mr-1">Cargando Plantillas ...</p>
							<v-progress-circular
								indeterminate
								:color="color"
								width="1"
								size="12"
							></v-progress-circular>
						</div>
						<div class="d-flex align-center justify-space-between py-1 w-100" v-else>
							<p class="mb-0 caption mr-1">Seleccionar Plantilla</p>
							<v-icon>mdi-chevron-down</v-icon>
						</div>
					</v-btn>
				</template>
				<div class="white d-flex flex-column">
					<div>
						<v-list dense>
							<v-list-item v-if="type == 'cost_table_payments'">
								<div class="d-flex align-center" style="gap: 10px;">
									<v-icon small color="warning">mdi-information-outline</v-icon>
									<p class="mb-0" style="font-size: 10px;">Cambiar la plantilla modificará los estados de pago y la programación</p>
								</div>
							</v-list-item>
							<v-list-item
								v-if="companyTemplatesByType.length === 0"
								disabled
							>
								<p class="mb-0 caption">No hay plantillas disponibles</p>
							</v-list-item>
							<v-list-item
								dense
								v-for="(template, i) in companyTemplatesByType" :key="'t-' + i"
								@click="onTemplateSelection(template)">
								<div class="d-flex align-center justify-space-between" style="width: 100%;">
									<p class="mb-0 font-weight-bold caption">{{ template.title }}</p>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												fab
												dark
												x-small
												icon
												color="error"
												@click.stop="deleteTemplate(template.id)"
												v-bind="attrs"
												v-on="on"
											>
												<v-icon small dark>mdi-delete-outline</v-icon>
											</v-btn>
										</template>
										<span>Eliminar</span>
									</v-tooltip>
								</div>
							</v-list-item>
						</v-list>
					</div>
				</div>
			</v-menu>
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						depressed
						:color="color"
						small
						outlined
						:disabled="disabled"
						@click="startNewTemplateCreation"
						v-bind="attrs"
						v-on="on"
					>
						<v-icon small>mdi-file-document-plus-outline</v-icon>
					</v-btn>
				</template>
				<span>Guardar contenido actual como plantilla</span>
			</v-tooltip>
		</div>
	</div>
</template>
<script>
import { createCompanyDocumentTemplate, deleteCompanyDocumentTemplate } from '@/helpers/api/company'
export default {
	name: 'CompanyTemplatesHandler',
	props: {
		type: {
			type: String,
			default: 'report',
		},
		itemContent: {
			type: [Object, Array],
			required: true,
			default: () => ({}),
		},
		itemContentHtml: {
			type: String,
			required: false,
			default: null,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		loadingHtmlContent: {
			type: Boolean,
			default: false,
		},
		color: {
			type: String,
			default: '#524D4D',
		},
	},
	computed: {
		userInfo(){
			return this.$store.state.user.userInfo
		},
		loadingCompanyTemplates(){
			return this.$store.state.companies.loadingCompanyDocumentTemplates
		},
		companyTemplates(){
			return this.$store.state.companies.companyDocumentTemplates
		},
		companyTemplatesByType(){
			if(this.type){
				return this.companyTemplates.filter(t => t.type === this.typeMap[this.type])
			}
			return this.companyTemplates
		},
    textFieldStyle() {
      return {
        '--field-color': this.color
      }
    }
	},
	data(){
		return {
			menuTemplates: false,
			createNewTemplate: false,
			newTemplateName: null,
			typeMap:	{
				'report': 1,
				'budget': 2,
				'contract': 3,
				'cost_table': 4,
				'cost_table_payments': 5,
				'addendum': 6,
				'subcontract': 7,
				'supervision': 8,
				'onlyoffice_report': 1,
			}
		}
	},
	mounted(){
		if(this.companyTemplates.length === 0){
			this.$store.dispatch('companies/getCompanyTemplates')
		}
	},
	methods: {
		async onTemplateSelection(template){
			const htmlContentUrl = template.file?.file_link
			fetch(htmlContentUrl)
				.then(response => response.text())
				.then(data => {
					const content = JSON.parse(data)
					this.$emit('template-content-selected', content)
					this.menuTemplates = false
				})
				.catch((error) => {
					console.log('Fetch error:', error);
					this.menuTemplates = false
				});
		},
		startNewTemplateCreation(){
			this.createNewTemplate = true
			if(this.type== 'onlyoffice_report'){
				this.$emit('request-html-content')
			}
		},
		async saveItemContentAsTemplate(){
			let infoToSave = this.itemContent
			if(this.type == 'budget'){
				infoToSave = {
					categories: this.itemContent.categories,
					description: this.itemContent.description,
					title: this.itemContent.title,
				}
			}
			else if(this.type == 'cost_table'){
				infoToSave = this.itemContent
			}
			else if(this.type == 'onlyoffice_report'){
				if(this.itemContentHtml){
					infoToSave = {
						title: this.itemContent.title,
						content: this.itemContentHtml
					}
				}
				else{
					return
				}
			}
			else if(this.type == 'cost_table_payments'){
				// infoToSave = this.itemContent.map(payment => ({
				// 	stage: payment.stage,
				// 	payments: payment.payments,
				// 	subcontract_payments: payment.subcontract_payments
				// }))
				infoToSave = this.itemContent.map(payment => (payment.stage))
			}
			if(this.type == 'contract'){
				infoToSave = (this.itemContent || []).map((section, sectionIndex) => ({
					title: section.title ?? '',
					subtitle: section.subtitle ?? null,
					section_type: section.section_type ?? 'text',
					order: sectionIndex,
					contents: (section.contents || []).map((content, itemIndex) => ({
						title: content.title ?? '',
						content: content.content ?? '',
						order: itemIndex,
						company_contract_section_id: content.company_contract_section_id ?? null
					}))
				}))
			}
			else if(this.type == 'supervision'){
				infoToSave = (this.itemContent || []).map(item => Object.fromEntries(Object.entries(item).filter(([key]) => key !== 'id')))
			}
			const data = {
				title: this.newTemplateName,
				type: this.typeMap[this.type],
				contents: JSON.stringify(infoToSave)
			}
			await createCompanyDocumentTemplate(data)
			this.$store.dispatch('companies/getCompanyTemplates')
			this.createNewTemplate = false
		},
		async deleteTemplate(template_id){
			await deleteCompanyDocumentTemplate({template_id})
			this.$store.dispatch('companies/getCompanyTemplates')
		},
	},
}
</script>

<style scoped>
/* Borde normal */
.custom-dynamic-color.v-text-field--outlined >>> fieldset {
  border-color: var(--field-color) !important;
}

/* Borde cuando está enfocado */
.custom-dynamic-color.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: var(--field-color) !important;
  border-width: 2px;
}

/* Label normal */
.custom-dynamic-color >>> .v-label {
  color: var(--field-color) !important;
}

/* Label cuando está enfocado o tiene contenido */
.custom-dynamic-color.v-input--is-focused >>> .v-label,
.custom-dynamic-color.v-input--has-state >>> .v-label {
  color: var(--field-color) !important;
}

/* Texto del input */
.custom-dynamic-color >>> input {
  color: var(--field-color) !important;
}

/* Placeholder */
.custom-dynamic-color >>> input::placeholder {
  color: var(--field-color) !important;
  opacity: 0.6;
}
</style>